import { render } from "./ApplicantRegisterView.vue?vue&type=template&id=38455da2&scoped=true"
import script from "./ApplicantRegisterView.vue?vue&type=script&lang=js"
export * from "./ApplicantRegisterView.vue?vue&type=script&lang=js"

import "@/assets/css/applicantReg.css?vue&type=style&index=0&id=38455da2&lang=css&scoped=true&external"
import "./ApplicantRegisterView.vue?vue&type=style&index=1&id=38455da2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38455da2"]])

export default __exports__